export default __webpack_public_path__ + "static/media/Minicard_5c.16480bc4.svg";